import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { withDefaults } from "@/lib/sections";
import { SectionShell, SectionHeading } from "./shared";

export const FaqSection = ({ id, content }) => {
  const c = withDefaults("faq", content);
  return (
    <SectionShell id={`s-${id}`} testId={`custom-section-${id}`}>
      <SectionHeading eyebrow={c.eyebrow} title={c.title} />
      <Accordion type="single" collapsible className="mt-10 max-w-3xl">
        {(c.items || []).map((f, i) => (
          <AccordionItem key={i} value={`q-${i}`} className="border-white/10">
            <AccordionTrigger className="text-left text-white hover:no-underline" data-testid={`faq-q-${id}-${i}`}>
              {f.question}
            </AccordionTrigger>
            <AccordionContent className="whitespace-pre-line text-slate-400">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </SectionShell>
  );
};

export default FaqSection;
